$( function () {

  $(document).on('click', '.js-detail-rating-link', e => {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $container = $target.parents('.js-detail-rating-item')
    const $content = $container.find('.js-detail-rating-content')
    $container.hasClass('active') ? $content.css({ 'display' : 'block' }) : $content.css({ 'display' : 'none' })
    $content.slideToggle(300)
    $container.toggleClass('active')
  })

  $(document).on('click', '.js-rating-buttons-open', e => {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $container = $target.parents('.js-rating-buttons')
    const $content = $target.next('.js-rating-buttons-popup')
    if ( $container.hasClass('active')) {
      $container.removeClass('active')
      $content.fadeOut(150)
    } else {
      $('.js-rating-buttons').removeClass('active')
      $('.js-rating-buttons-popup').fadeOut(150)
      $container.addClass('active')
      $content.fadeIn(150)
    }
  })

  $(document).on('click', e => {
    if ( !$('.js-rating-buttons-open').is(e.target) && $('.js-rating-buttons-open').has(e.target).length === 0 ) {
      $('.js-rating-buttons').removeClass('active')
      $('.js-rating-buttons-popup').fadeOut(150)
    }
  })

})